import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingLoadingBox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.95 16.765h1.53v1.52h-1.53Z\"/><path fill=\"currentColor\" d=\"M27.43 15.245h-7.62v-1.53h-1.52v1.53h-4.57v-1.53h-1.53v1.53H4.57v1.52h12.19v1.52h1.53v10.67H6.1v-7.62h9.14v-1.52H3.05v-1.53H1.52v1.53H0v1.52h4.57v9.14h22.86v-9.14H32v-3.05h-1.52v1.53h-3.05v-3.05h1.52v-3.05h-1.52Zm-1.52 13.71h-6.1v-12.19h6.1Z\"/><path fill=\"currentColor\" d=\"M21.33 12.195h7.62v1.52h1.53v-1.52H32v-1.53H21.33zm-1.52 0h1.52v1.52h-1.52Zm-4.57 6.09h1.52v1.53h-1.52Zm-1.52-9.14h1.52v1.52h1.52v-1.52h1.53v-1.52h1.52v-1.53h-3.05v-4.57h-1.52v4.57h-3.05v1.53h1.53zm-3.05 3.05h1.52v1.52h-1.52Zm-7.62 4.57h1.52v1.52H3.05Zm0-3.05h1.52v1.53H3.05Zm7.62-1.52v-1.53H0v1.53h1.52v1.52h1.53v-1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingLoadingBox
